module.exports = __webpack_public_path__ + "img/camion-citerne-bleu.e87beced.jpg";